var map = {
	"./authentication.js": 670,
	"./confirm-dialog.js": 7077,
	"./dialogs.js": 7078,
	"./event.js": 7079,
	"./items.js": 7083,
	"./login-dialog.js": 7084,
	"./snack-bar.js": 7085,
	"./stream.js": 580,
	"./tickets.js": 7086,
	"./viewers.js": 7087,
	"./window.js": 7088
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7076;


//////////////////
// WEBPACK FOOTER
// ./src/reducers ^(.*\.(js$))[^.]*$/i
// module id = 7076
// module chunks = 0